
import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@mui/material/styles'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Typography from '@mui/material/Typography';
import { useSelector, useDispatch } from 'react-redux'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { useTranslation } from "react-i18next";
import MapIcon from '@mui/icons-material/Map';
import SpeedDial from "@mui/material/SpeedDial";
import SpeedDialAction from "@mui/material/SpeedDialAction";
import TableRowsIcon from "@mui/icons-material/TableRows";
import SortIcon from '@mui/icons-material/Sort';
import TelegramIcon from "@mui/icons-material/Telegram";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CachedIcon from '@mui/icons-material/Cached';
import SpeedDialTooltipOpen from './SpeedDialTooltipOpen';
import SearchResultComponent from '../../../Components/SearchResultComponent';


const StyledSpeedDial = styled(SpeedDial)(({ theme, gridtheme }) => ({
  // position: 'relative',
  position: 'relative',
  // top:0,
  // left:'50px',
  // zIndex:3000,
  // display:'block',
  width: '50px',
  height: '36px',
  '& .MuiFab-root-MuiSpeedDial-fab': {
    width: 40,
    height: 40,
    backgroundColor: `${gridtheme?.primaryColor}44 !important`,


  },
  '& .MuiFab-root-MuiSpeedDial-fab:hover': {
    backgroundColor: `${gridtheme?.secondary} !important`,
  },
  // backgroundColor: `${gridtheme?.primaryColor}44 !important`,
  padding: 0,
  // '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
  //   bottom: 0,
  //   right:0,
  // },
  // '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
  //   top: 0,
  //   left: 0,
  //   backgroundColor:`${gridtheme?.primaryColor}44 !important`,
  // },
  '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
    // bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
    // top: theme.spacing(2),
    left: theme.spacing(2),
  },
}));

export default function CustomeFilter(props) {
  const { t } = useTranslation('common');
  const SearchButtonTheme = useSelector(state => state.settingsData.SearchButtonTheme);
  const gridtheme = useSelector(state => state.themeData.gridtheme)
  const maintheme = useSelector(state => state.themeData.maintheme)
  const [actions, setActions] = useState([])
  const [hidden, setHidden] = React.useState(false);
  // const {search_button_color,clear_button_color,search_button_text_color,clear_button_text_color} =SearchButtonTheme

  const divRef = useRef(null);


  const [hideSearch, setHideSearch] = useState(true)
  useEffect(() => {
    const emptyArray = [];
    // if (props?.hasExport) {
    //   emptyArray.push({ icon: <FileDownloadIcon onClick={props?.exportFunction} sx={{ color: gridtheme?.tooltip_export_text + " !important" }} />, color: gridtheme?.tooltip_export, name: t('TOOLTIP.EXPORT') })
    // }
    if (props?.hasCreate) {
      emptyArray.push({ icon: <AddIcon onClick={props?.createFunction} sx={{ color: maintheme?.primary + " !important" }} />, color: gridtheme?.tooltip_create, name: t('TOOLTIP.CREATE') })
    }
    if (props?.hasMaps) {
      emptyArray.push({ icon: <MapIcon onClick={props?.mapFunction} sx={{ color: gridtheme?.tooltip_map_text + " !important" }} />, color: gridtheme?.tooltip_map, name: t('TOOLTIP.MAP') })
    }
    // if (props?.hasImport) {
    //   emptyArray.push({ icon: <FileUploadIcon onClick={props?.importFunction} sx={{ color: gridtheme?.tooltip_import_text + " !important" }} />, color: gridtheme?.tooltip_import, name: t('TOOLTIP.IMPORT') })
    // }
    if (props?.hasTelegram) {
      emptyArray.push({ icon: <TelegramIcon onClick={props?.telegramFunction} sx={{ color: gridtheme?.tooltip_telegram_text + " !important" }} />, color: gridtheme?.tooltip_telegram, name: t('TOOLTIP.SEND_TELEGRAM') })
    }
    if (props?.hasView) {
      emptyArray.push({ icon: <RemoveRedEyeIcon onClick={props?.viewFunction} sx={{ color: gridtheme?.tooltip_view_text + " !important" }} />, color: gridtheme?.tooltip_view, name: t('TOOLTIP.VIEW') })
    }
    setActions(emptyArray);
  }, [props, SearchButtonTheme])




  const handleClickOutside = (event) => {
    if (divRef.current && !divRef.current.contains(event.target)) {
      // setHideSearch(true);
    }
  };


  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Box
      sx={{
        width: '100% !important',
        paddingTop: '5px'
      }}
      onKeyDown={(event) => {


        if (event.key === 'Enter') {
          props?.searchFunction()
          setHideSearch(true)
          event.preventDefault();
        }

      }}
    >

      <Box
        sx={{
          position: 'relative',
          width: '100% !important',
          height: 'fit-content',
          borderRadius: '5px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: `${gridtheme?.lightblack} !important`,
          '& > div': {
            width: 'auto !important',
            justifyContent: 'flex-start',
            flex: 1
          },
          '& > div div': {
            flex: 'none !important'
          },
          '& .rightHeaderComponent': {
            width: 'auto !important',
            flex: 'none !important'
          },
          '& > hr': {
            display: "none !important"
          }
        }}
      >
        {props?.LeftHeaderComponent}
        <Box
          sx={{
            width: 'fit-content',
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'flex-end',
            minWidth: "10%",
            maxWidth: '50%',
            position: 'relative',
            top: '-5px',
            gap: '5px'
          }}
          className="rightHeaderComponent"
        >

          {props?.resultSideButton}
          <SearchResultComponent
            resultLength={props?.resultLength}
            totalWeight={props?.totalWeight}
          />
          {props?.dosntHaveRefresh ? null :
            <Tooltip
              title={<span style={{ fontFamily: "Cairo" }}>{t("GLOBAL.refresh")}</span>}
              arrow
              TransitionProps={{ timeout: 200 }}
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    color: '#333',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    fontFamily: 'Cairo',
                  }
                }
              }}
            >
              <IconButton
                sx={{
                  padding: "10px",
                  // marginRight: '12px',
                  backgroundColor: `${gridtheme?.gridHeader}22`,
                  borderRadius: '10px',
                  border: `1px solid ${gridtheme?.gridHeader}44`,
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    backgroundColor: `${gridtheme?.gridHeader}`,
                    '& .MuiSvgIcon-root': {
                      color: '#fff !important',
                    },
                  },
                }}
                onClick={() => {
                  props?.searchFunction()
                }}
              >
                {hideSearch ?
                  <CachedIcon sx={{
                    fontSize: "24px",
                    color: gridtheme?.gridHeader,
                    transition: 'color 0.15s ease',
                  }} />
                  :
                  null
                }
              </IconButton>
            </Tooltip>
          }
          {
            props?.hasColumnsHidShow ?
              <Tooltip
                title={<span style={{ fontFamily: "Cairo" }}>{t("GLOBAL.show_hide_columns")}</span>}
                arrow
                TransitionProps={{ timeout: 200 }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      backdropFilter: 'blur(10px)',
                      color: '#333',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                      borderRadius: '8px',
                      fontFamily: 'Cairo',
                    }
                  }
                }}
              >
                <IconButton
                  sx={{
                    padding: "10px",
                    // marginLeft: '8px',
                    backgroundColor: `${gridtheme?.gridHeader}22`,
                    borderRadius: '10px',
                    border: `1px solid ${gridtheme?.gridHeader}44`,
                    transition: 'all 0.15s ease',
                    '&:hover': {
                      backgroundColor: `${gridtheme?.gridHeader}`,
                      '& .MuiSvgIcon-root': {
                        color: '#fff !important',
                      },
                    },
                  }}
                  onClick={() => {
                    props?.setOpenFilterColumn(!props?.openFilterColumn);
                  }}
                >
                  <TableRowsIcon sx={{
                    fontSize: "22px",
                    color: gridtheme?.gridHeader,
                    transition: 'color 0.15s ease',
                  }} />
                </IconButton>
              </Tooltip> : null

          }
          {
            props?.hasColumnsSorting ?
              <Tooltip
                title={<span style={{ fontFamily: "Cairo" }}>{t("GLOBAL.sort_columns")}</span>}
                arrow
                TransitionProps={{ timeout: 200 }}
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: 'rgba(255, 255, 255, 0.95)',
                      backdropFilter: 'blur(10px)',
                      color: '#333',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                      borderRadius: '8px',
                      fontFamily: 'Cairo',
                    }
                  }
                }}
              >
                <IconButton
                  sx={{
                    padding: "10px",
                    // marginLeft: '8px',
                    backgroundColor: `${gridtheme?.gridHeader}22`,
                    borderRadius: '10px',
                    border: `1px solid ${gridtheme?.gridHeader}44`,
                    transition: 'all 0.15s ease',
                    '&:hover': {
                      backgroundColor: `${gridtheme?.gridHeader}`,
                      '& .MuiSvgIcon-root': {
                        color: '#fff !important',
                      },
                    },
                  }}
                  onClick={() => {
                    props?.setOpenSortColumn(!props?.openSortColumn);
                  }}
                >
                  <SortIcon sx={{
                    fontSize: "22px",
                    color: gridtheme?.gridHeader,
                    transition: 'color 0.15s ease',
                  }} />
                </IconButton>
              </Tooltip> : null

          }
          {props?.hasExport ?
            <Tooltip
              title={<span style={{ fontFamily: "Cairo" }}>{t("GLOBAL.export_data")}</span>}
              arrow
              TransitionProps={{ timeout: 200 }}
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    color: '#333',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    fontFamily: 'Cairo',
                  }
                }
              }}
            >
              <IconButton
                sx={{
                  padding: "10px",
                  // marginRight: '8px',
                  backgroundColor: '#27ae6022',
                  borderRadius: '10px',
                  border: '1px solid #27ae6044',
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    backgroundColor: '#27ae60',
                    '& .MuiSvgIcon-root': {
                      color: '#fff !important',
                    },
                  },
                }}
                onClick={() => {
                  props?.exportFunction()
                }}
              >
                <FileDownloadIcon
                  sx={{
                    fontSize: "22px",
                    color: '#27ae60',
                    transition: 'color 0.15s ease',
                  }}
                />
              </IconButton>
            </Tooltip>
            : null}
          {props?.multipleExports?.length ?
            <SpeedDialTooltipOpen
              label={t("GLOBAL.show_hide_columns")}
              icon={<FileDownloadIcon
                sx={{
                  fontSize: "28px",
                  color: gridtheme?.colorWhite
                }}
              />}
              actions={props?.multipleExports}
            />

            : null}
          {props?.hasImport ?
            <Tooltip
              title={<span style={{ fontFamily: "Cairo" }}>{t("GLOBAL.import_data")}</span>}
              arrow
              TransitionProps={{ timeout: 200 }}
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    color: '#333',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    fontFamily: 'Cairo',
                  }
                }
              }}
            >
              <IconButton
                sx={{
                  padding: "10px",
                  // marginRight: '8px',
                  backgroundColor: '#3498db22',
                  borderRadius: '10px',
                  border: '1px solid #3498db44',
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    backgroundColor: '#3498db',
                    '& .MuiSvgIcon-root': {
                      color: '#fff !important',
                    },
                  },
                }}
                onClick={() => {
                  props?.importFunction()
                }}
              >
                <FileUploadIcon
                  sx={{
                    fontSize: "22px",
                    color: '#3498db',
                    transition: 'color 0.15s ease',
                  }}
                />
              </IconButton>
            </Tooltip>
            : null}
          {props?.dosntHaveSearch ? null :
            <Tooltip
              title={<span style={{ fontFamily: "Cairo" }}>{t("GLOBAL.show_hide_search")}</span>}
              arrow
              TransitionProps={{ timeout: 200 }}
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    color: '#333',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    borderRadius: '8px',
                    fontFamily: 'Cairo',
                  }
                }
              }}
            >
              <IconButton
                sx={{
                  padding: "10px",
                  backgroundColor: maintheme?.secondary,
                  borderRadius: '10px',
                  boxShadow: `0 2px 8px ${maintheme?.secondary}44`,
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    backgroundColor: `${maintheme?.secondary}dd`,
                  },
                }}
                onClick={() => {
                  setHideSearch(!hideSearch)
                }}
              >
                {hideSearch ?
                  <SearchIcon sx={{
                    fontSize: "24px",
                    color: '#fff',
                  }} />
                  :
                  null
                }
              </IconButton>
            </Tooltip>}
        </Box>
      </Box>

      <Drawer
        anchor="right"
        open={!hideSearch}
        onClose={() => setHideSearch(true)}
        transitionDuration={150}
        PaperProps={{
          sx: {
            width: props?.filterHasSelectCounter ? '360px' : '320px',
            height: 'calc(100vh - 60px)',
            top: '60px !important',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            boxShadow: '-8px 0 32px rgba(0, 0, 0, 0.1)',
            // borderRadius: '24px 0 0 24px',
            borderLeft: '1px solid ' + maintheme?.primary,
            display: 'flex',
            flexDirection: 'column',
          }
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              backdropFilter: 'blur(2px)',
              top: '60px',
            }
          }
        }}
      >
        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            width: "100%",
            position: 'relative',
            background: `linear-gradient(135deg, ${maintheme?.secondary} 0%, ${maintheme?.secondary}dd 100%)`,
            height: '64px',
            minHeight: '64px',
            alignItems: 'center',
            justifyContent: 'space-between',
            zIndex: 10,
            boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
            padding: '0 16px',
          }}
        >
          {!props?.filterHasSelectCounter ? (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <StyledSpeedDial
                gridtheme={maintheme}
                ariaLabel="Search actions"
                hidden={hidden}
                icon={<MoreVertIcon sx={{ color: '#fff' }} />}
                direction='right'
                sx={{
                  '& .MuiSpeedDial-fab': {
                    backgroundColor: 'rgba(255,255,255,0.2)',
                    backdropFilter: 'blur(10px)',
                    width: '36px',
                    height: '36px',
                    minHeight: '36px',
                    '&:hover': {
                      backgroundColor: 'rgba(255,255,255,0.3)',
                    },
                    '& .MuiSvgIcon-root': {
                      fontSize: '20px',
                    }
                  }
                }}
              >
                {actions.map((action) => (
                  <SpeedDialAction
                    key={action.name}
                    icon={action.icon}
                    tooltipTitle={<span style={{ fontFamily: 'Cairo-Medium' }}>{action.name}</span>}
                    sx={{
                      backgroundColor: action?.color || '#00f',
                      '&:hover': {
                        backgroundColor: action?.color || '#00f',
                      },
                    }}
                  />
                ))}
              </StyledSpeedDial>
            </Box>
          ) : (
            <Box
              sx={{
                height: '32px',
                borderRadius: '8px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'rgba(255,255,255,0.2)',
                backdropFilter: 'blur(10px)',
                color: '#fff',
                padding: '0 12px',
                border: '1px solid rgba(255,255,255,0.3)',
              }}
            >
              <Typography
                sx={{
                  fontSize: '13px',
                  fontFamily: 'Cairo-Bold',
                  color: '#fff',
                }}
              >
                {t('GLOBAL.SEARCH_RESULT_OF_selected')} {props?.filterHasSelectCounterValue}
              </Typography>
            </Box>
          )}

          <Box
            sx={{
              height: '32px',
              borderRadius: '8px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: 'rgba(255,255,255,0.95)',
              color: maintheme?.secondary,
              padding: '0 12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            <Typography
              sx={{
                fontSize: '13px',
                color: maintheme?.secondary,
                fontFamily: 'Cairo-Bold',
              }}
            >
              {t('GLOBAL.SEARCH_RESULT_OF_SEARCH')} {props?.resultLength}
            </Typography>
          </Box>
        </Box>

        {/* Content Section */}
        <Box
          sx={{
            flexGrow: 1,
            overflowY: 'auto',
            padding: '24px 16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            '& .MuiInputLabel-root': {
              fontFamily: 'Cairo',
              fontSize: '14px',
            },
            '& .MuiInputBase-root': {
              borderRadius: '12px',
              fontFamily: 'Cairo',
              '&:hover': {
                backgroundColor: 'rgba(0,0,0,0.02)',
              }
            },
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              background: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              background: `${maintheme?.secondary}22`,
              borderRadius: '3px',
              '&:hover': {
                background: `${maintheme?.secondary}44`,
              },
            },
          }}
        >
          {props?.children}
        </Box>

        {/* Footer Section */}
        <Box
          sx={{
            padding: '16px 20px',
            display: 'flex',
            gap: '12px',
            backgroundColor: 'rgba(255,255,255,0.8)',
            backdropFilter: 'blur(10px)',
            borderTop: '1px solid rgba(0,0,0,0.06)',
            boxShadow: '0 -4px 12px rgba(0,0,0,0.02)',
          }}
        >
          <Button
            variant="outlined"
            onClick={() => props.clearFunction()}
            sx={{
              flex: 1,
              height: '44px',
              borderRadius: '12px',
              border: `2px solid ${maintheme?.secondary}44`,
              color: maintheme?.secondary,
              fontFamily: 'Cairo-Bold',
              fontSize: '14px',
              textTransform: 'none',
              '&:hover': {
                border: `2px solid ${maintheme?.secondary}`,
                backgroundColor: `${maintheme?.secondary}11`,
                transform: 'translateY(-1px)',
              }
            }}
          >
            {t('GLOBAL.SEARCH_CLEAR_BUTTON')}
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              setHideSearch(true);
              props.searchFunction();
            }}
            sx={{
              flex: 1,
              height: '44px',
              borderRadius: '12px',
              backgroundColor: maintheme?.secondary,
              fontFamily: 'Cairo-Bold',
              fontSize: '14px',
              textTransform: 'none',
              boxShadow: `0 8px 16px ${maintheme?.secondary}44`,
              '&:hover': {
                backgroundColor: maintheme?.secondary,
                boxShadow: `0 12px 20px ${maintheme?.secondary}66`,
                transform: 'translateY(-1px)',
              },
              '&:active': {
                transform: 'translateY(0)',
              }
            }}
          >
            {t('GLOBAL.SEARCH_SEARCH_BUTTON')}
          </Button>
        </Box>
      </Drawer>
    </Box>

  );
}
